import React from "react";
import { connect } from "react-redux";
import Section from "../../UI/Section";
import Panel from "../../UI/Panel";
import PanelBody from "../../UI/Panel/PanelBody";
import PageSubTitle from "../../UI/PageSubTitle";
import { Link } from "react-router-dom";
import getMyMobileNumber from "../../../_selectors/userSelectors/getMyMobileNumber";
import MobileNumber from "./MobileNumber";

const Update = ({ mobile }) => {
  return (
    <Section>
      <div className="row">
        <div className="col-sm-4">
          {mobile === null ? (
            <MobileNumber />
          ) : (
            <Panel>
              <PanelBody>
                <PageSubTitle center>
                  <h3>Profile</h3>
                  <p>
                    We will help you find your special one through your profile
                  </p>
                </PageSubTitle>
                <div className="input-group">
                  <div className="input-group-btn text-center">
                    <Link to={`/profile`} className="btn btn-success btn-sm ">
                      Update Profile
                    </Link>
                  </div>
                </div>
              </PanelBody>
            </Panel>
          )}
        </div>
        <div className="col-sm-4">
          <Panel>
            <PanelBody>
              <PageSubTitle center>
                <h3>Partner Preference</h3>
                <p>
                  Share your interests. We will help you find your special one.
                </p>
              </PageSubTitle>
              <div className="input-group">
                <div className="input-group-btn text-center">
                  <Link
                    to={`/profile/partner-preference`}
                    className="btn btn-success btn-sm "
                  >
                    Update Preference
                  </Link>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
        <div className="col-sm-4">
          <Panel>
            <PanelBody>
              <PageSubTitle center>
                <h3>Privacy</h3>
                <p>You are in control of your privacy.</p>
              </PageSubTitle>
              <div className="input-group">
                <div className="input-group-btn text-center">
                  <Link
                    to={`/profile/privacy`}
                    className="btn btn-success btn-sm "
                  >
                    Update Privacy
                  </Link>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </Section>
  );
};
const mapStateToProps = (state, ownProps) => ({
  mobile: getMyMobileNumber(state)
});

export default connect(mapStateToProps)(Update);



// WEBPACK FOOTER //
// ./src/_components/Home/Update/index.js